import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../../style/controls/presetSelector.scss";
import { Tag } from "antd";
import { observer } from "mobx-react";
import { useCallback, useState } from "react";
import { UPSELL_TAG_BACKGROUND_COLOR, useUpsellModal } from "@devowl-wp/react-cookie-banner-admin";
import { INTERVAL_SWITCH_INDIVIDUAL_PRIVACY_SECONDS } from "./presetSelector.js";
import { BannerPreset } from "../../models/bannerPreset.js";
import { __ } from "../../utils/i18n.js";
let renderTimeout;
let individualPrivacyInterval;
const CustomizePresetCard = observer(({ preset, onApply })=>{
    const [applied, setApplied] = useState(false);
    const { isPro, open: openProModal, modal } = useUpsellModal({
        title: __("Want to use %s preset?", preset.name),
        testDrive: true,
        feature: "customize-preset",
        description: __("Only a limited number of presets are available for the free version of Real Cookie Banner. Start now with the PRO version and create a design from a preset with just one click.")
    });
    const iframeStore = BannerPreset.getIframeStore().customizeBannerStore;
    const handleMouseEnter = useCallback(()=>{
        clearTimeout(renderTimeout);
        clearInterval(individualPrivacyInterval);
        renderTimeout = setTimeout(()=>{
            setApplied(false);
            preset.previewInUi();
            // Toggle individual privacy preference after x seconds
            individualPrivacyInterval = setInterval(()=>{
                iframeStore.setIndividualPrivacyOpen(!iframeStore.individualPrivacyOpen);
            }, INTERVAL_SWITCH_INDIVIDUAL_PRIVACY_SECONDS * 1000);
        }, 100);
    }, [
        setApplied,
        preset,
        iframeStore
    ]);
    const handleMouseLeave = useCallback(()=>{
        clearTimeout(renderTimeout);
        clearInterval(individualPrivacyInterval);
        iframeStore.setIndividualPrivacyOpen(false);
        if (!applied) {
            renderTimeout = setTimeout(()=>{
                preset.resetPreviewInUi();
            }, 100);
        }
    }, [
        preset,
        applied
    ]);
    const handleClick = useCallback(()=>{
        clearInterval(individualPrivacyInterval);
        if (!preset.applyInUi()) {
            // Can currently only return `false` when not in Pro version
            openProModal();
        } else {
            setApplied(true);
            onApply?.();
        }
    }, [
        setApplied,
        preset
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "customize-rcb-preset",
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: [
            modal,
            /*#__PURE__*/ _jsxs("strong", {
                children: [
                    preset.name,
                    " ",
                    !isPro && preset.needsPro && /*#__PURE__*/ _jsx(Tag, {
                        color: UPSELL_TAG_BACKGROUND_COLOR,
                        children: "PRO"
                    }),
                    preset.tags?.map(([color, text])=>/*#__PURE__*/ _jsx(Tag, {
                            color: color,
                            children: text
                        }, text))
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                children: preset.description
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "btn-apply hidden",
                onClick: handleClick,
                children: applied ? __("Applied!") : __("Apply")
            })
        ]
    });
});
export { CustomizePresetCard };
